import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
import ServiceModeToggle from '../../components/navigation/ServiceModeToggle';
import ContentFilterTabs from '../restaurant-details/components/ContentFilterTabs';
import SectionScrollNavigation from '../../components/navigation/SectionScrollNavigation';
import LocationHeader from './components/LocationHeader';
import SearchBar from './components/SearchBar';
import HeroBanner from './components/HeroBanner';
import CategoriesSection from './components/CategoriesSection';
import OffersSection from './components/OffersSection';
import CouponsSection from './components/CouponsSection';
import RestaurantsSection from './components/RestaurantsSection';
import HomeRestaurantsFeedSection from './components/HomeRestaurantsFeedSection';
import ActiveOrderSection from './components/ActiveOrderSection';
import DeliveryTrackingSection from './components/ActiveOrderSection';
import Footer from 'components/Footer';
import SearchBarSuggest from './components/SearchBarSuggest';

const RestaurantHomePage = () => {
  const [search, setSearch] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>المطاعم - يسلمو</title>
      </Helmet>


      <div className="min-h-screen bg-[#F8F8F8] smooth-scroll">
        <ResponsiveTopNavigation />

        <main className="pt-14">
          {/* <LocationHeader /> */}
          <div className="flex flex-col lg:flex-row lg:items-center mt-2">
            <div className="lg:w-[30%]">
              <ServiceModeToggle />
            </div>

            <div className="lg:flex-1">
              <SearchBarSuggest />
            </div>
          </div>
          <ContentFilterTabs />
          <HeroBanner />
          <DeliveryTrackingSection />
          <SectionScrollNavigation />
          <CategoriesSection />
          <OffersSection />
          <CouponsSection />
          <HomeRestaurantsFeedSection
            sectionId="home-new-restaurants"
            title="جديد على يسلمو"
            feedKey="new"
          />
          <HomeRestaurantsFeedSection
            sectionId="home-lowest-delivery"
            title="توصيل سريع"
            feedKey="lowest-delivery"
          />
          <RestaurantsSection />
          
          {/* <Footer /> */}
        </main>
      </div>
    </>
  );
};

export default RestaurantHomePage;